module.exports = __webpack_public_path__ + "static/media/colicoli25.ac485e21.webp";